import styled from 'styled-components';

export default styled.h1`
  font-family: ${({ theme }) => theme.fonts.bold};
  font-style: normal;
  /* font-weight: 700; */
  font-size: ${({ theme }) => theme.fontSizes.l};
  line-height: 28.8px;
  color: ${({ theme }) => theme.colors.elvitaTrueBlack};
`;
